import { Component, OnInit, inject } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {ProjectService, TranslationService, UserService} from '../../services';
import {FormUtil} from '../../utils';

@Component({
    selector: 'app-create-project-modal',
    templateUrl: './create-project-modal.component.html',
    standalone: false
})
export class CreateProjectModalComponent implements OnInit {
    private projectService = inject(ProjectService);
    private userService = inject(UserService);
    public modalRef = inject(VwuiModalRef);
    private translationService = inject(TranslationService);


    public form = new UntypedFormGroup({
        name: new UntypedFormControl('', Validators.required),
        address: new UntypedFormControl('', Validators.required),
        city: new UntypedFormControl('', Validators.required),
        country: new UntypedFormControl('NL', Validators.required),
        companyName: new UntypedFormControl('', Validators.required)
    });
    public loading = false;
    public companyNames: string[];
    public countries: {id: string; name: string}[];

    constructor() {
        const translationService = this.translationService;

        this.countries = translationService.getCountriesAsKeyValue();
    }

    ngOnInit(): void {
        this.userService.getUserInfo().then((userInfo) => {
            this.companyNames = userInfo.getCompanyNamesForManuallyAddingProjects();
        });
    }

    async submit() {
        this.loading = true;

        try {
            FormUtil.validate(this.form);

            if (this.form.valid) {
                await this.projectService.createProject(this.form.value);
                this.modalRef.close(true);
            }
        } finally {
            this.loading = false;
        }
    }
}
